import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { produktgruppenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface Produktgruppe {
    nr: number;
    text: string;
}

export const defaultProduktgruppe: Produktgruppe = {
    nr: 0,
    text: '',
};

export function useProduktgruppenAsOptions(): SelectOption[] {
    const produktgruppen = useSelector(produktgruppenSelector);

    return React.useMemo<SelectOption[]>(() => {
        return produktgruppen.map(
            (produktgruppe) => ({ value: produktgruppe.nr.toString(), label: produktgruppe.text } as SelectOption),
        );
    }, [produktgruppen]);
}

export function useProduktgruppenByNr(): { [key: number]: Produktgruppe } {
    const produktgruppen = useSelector(produktgruppenSelector);

    return React.useMemo<{ [key: number]: Produktgruppe }>(() => {
        return produktgruppen.reduce<{ [key: number]: Produktgruppe }>(
            (acc, produktgruppe) => ({
                ...acc,
                [produktgruppe.nr]: produktgruppe,
            }),
            {},
        );
    }, [produktgruppen]);
}

export async function addProduktgruppe(produktgruppe: Produktgruppe): Promise<void> {
    return callApi<void>(Controller.produktgruppe + '/add', { produktgruppe });
}

export async function updateProduktgruppe(produktgruppe: Produktgruppe): Promise<void> {
    return callApi<void>(Controller.produktgruppe + '/update', { produktgruppe });
}

export async function deleteProduktgruppe(produktgruppe: Produktgruppe): Promise<void> {
    return callApi<void>(Controller.produktgruppe + '/update', { produktgruppe });
}
